import React, { useState } from "react";
import { LottieComponent01 } from "../../components/LottieComponents/LottieComponent01/LottieComponent01";
import { LottieComponent02 } from "../../components/LottieComponents/LottieComponent02/LottieComponent02";
import { LottieComponent03 } from "../../components/LottieComponents/LottieComponent03/LottieComponent03";
import "../../components/LottieComponents/LottieComponents.css";

export interface props {
	firstTime: boolean;
	toggleMenu: () => void;
	setFirstTime: (boolean: boolean) => void;
}

export const IntroComponent: React.FC<{} & props> = (props) => {
	const slidesWrapper = React.useRef<HTMLDivElement>(null);
	const [slideIndex, setSlideIndex] = useState(0);

	const slideToItem = (index: number) => {
		let percentage = index * -100;
		slidesWrapper.current.style.transform = `translate3d(${percentage}%, 0, 0)`;
		setSlideIndex(index);
	};

	return (
		<div
			className={
				"intro-component position-fixed w-100 h-100 d-flex align-items-center " +
				(props.firstTime ? " " : "hide")
			}
		>
			<div className="intro-container col-12 col-lg-8 offset-lg-2 d-flex flex-column justify-content-evenly">
				<div className="header-intro text-center">
					<h3 className="m-0 mb-2" style={{ fontSize: "2rem" }}>
						Introduktion
					</h3>
					<p
						className="introduction-text mb-4 col-sm-8 offset-sm-2"
						style={{ lineHeight: "1.5" }}
					>
						<strong>
							I en Tynd Tråd er en interaktiv oplevelse. <br />
							Det betyder at du selv bestemmer, hvordan historien udspiller sig.
						</strong>
					</p>
				</div>
				<div className="carousel-container">
					<div className="slide-container d-flex align-items-center">
						<div ref={slidesWrapper} className="slides-wrapper">
							<div className="slides-item item-01">
								<div className="lottie-container mx-auto">
									<LottieComponent01 />
								</div>
								<p
									className="col-sm-8 offset-sm-2 text-center mt-3 mb-0"
									style={{ lineHeight: "1.5" }}
								>
									I hver slutning af en scene, får du to valg.{" "}
									<br className="d-lg-block d-none" /> Brug de to knapper i
									bunden, for at vælge. <br className="d-lg-block d-none" />{" "}
									Husk på, dine valg har konsekvenser.
								</p>
							</div>
							<div className="slides-item item-02">
								<div className="lottie-container mx-auto">
									<LottieComponent02 />
								</div>
								<p
									className="col-sm-8 offset-sm-2 text-center mt-3 mb-0"
									style={{ lineHeight: "1.5" }}
								>
									Med OVERSIGT-knappen kan du se hvor langt du er nået.{" "}
									<br className="d-lg-block d-none" /> Du kan altid gå frem og
									tilbage i historien.
								</p>
							</div>
							<div className="slides-item item-03">
								<div className="lottie-container mx-auto">
									<LottieComponent03 />
								</div>
								<p
									className="col-sm-8 offset-sm-2 text-center mt-3 mb-0"
									style={{ lineHeight: "1.5" }}
								>
									Pause eller spol frem/tilbage i historien, oppe i højre
									hjørne. <br className="d-lg-block d-none" /> God fornøjelse!
								</p>
							</div>
						</div>
					</div>
					<ol className="slides-nav pb-3">
						<li
							onClick={(event) => {
								console.log(event.target);
								slideToItem(0);
							}}
							className={
								"slides-nav-item cursor-pointer " +
								(slideIndex === 0 ? "active" : "")
							}
						></li>
						<li
							onClick={(event) => {
								console.log(event.target);
								slideToItem(1);
							}}
							className={
								"slides-nav-item cursor-pointer " +
								(slideIndex === 1 ? "active" : "")
							}
						></li>
						<li
							onClick={(event) => {
								console.log(event.target);
								slideToItem(2);
							}}
							className={
								"slides-nav-item cursor-pointer " +
								(slideIndex === 2 ? "active" : "")
							}
						></li>
					</ol>
				</div>
				{/* Button */}
				<div>
					<button
						className="button primary mx-auto py-2 cursor-pointer"
						onClick={() => {
							props.toggleMenu();
							props.setFirstTime(false);
							if (document.activeElement instanceof HTMLButtonElement) {
								document.activeElement.blur();
							}
						}}
					>
						Start filmen
					</button>
				</div>
			</div>
		</div>
	);
};
